export default {
  path: '/pay',
  name: 'Pay',
  redirect: '/pay/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'payLsit',
      component: () => import('@/views/pay'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      name: 'payDetail',
      component: () => import('@/views/pay/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'renewDetail',
      name: 'payRenewDetail',
      component: () => import('@/views/pay/renewDetail'),
      meta: { requiresAuth: true }
    },
  ]
}
